import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';


import Select from 'react-select'; //04-03-2024-multiselect

import 'react-toastify/dist/ReactToastify.css';
import '../../Assets/css/resptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
import { disciplineStyles } from "../../Assets/js/customStyles.js";

export default function CollegeStudentCOAttainmentpdf() {

    const navigate = useNavigate();
    // CHECKING IF USER IS VALID
    const isAuth = useAuth();
    if (isAuth === false) {
        navigate("/college/")
    }

    const tableRef = useRef(null);

    const [disciplinedata, setDisciplineData] = useState([]);
    const [flag, setflag] = useState(false);
    const [getexamData, setExamData] = useState([]);
    const [selectedExamId, setSelectedExamId] = useState([]);
    const [selectExamId, setSelectExamId] = useState(false);
    const [selectExamType, setSelectExamType] = useState(false);
    const [disciplineId, setDisciplineId] = useState(null);
    const [disciplineName, setDisciplineName] = useState([]);
    const [disciplinetype, setDisciplineTypeChange] = useState(null);
    const [course, setCourse] = useState([]);
    const [courseId, setCourseId] = useState([]);
    const [courseName, setCourseName] = useState([]);
    const [loading, setloading] = useState(false);

    const { http } = Api();

    let cid = localStorage.getItem("collegeid");
    let username = localStorage.getItem("username");


    const handleChangeExam = (selectedOption) => {
        setSelectedExamId(selectedOption ? [selectedOption]: []);
        setSelectExamId(selectedOption.examid);
        setSelectExamType(selectedOption.examtype);
    }
    const handleDisciplineChange = (selectedOption) => {
        setDisciplineId(selectedOption.disciplineid);
        setDisciplineName(selectedOption.label);
        setDisciplineTypeChange(selectedOption.type); // Update the discipline type

    };
    const handlecourseChange = (selectedOption) => {
        setCourseId(selectedOption.value);
        setCourseName(selectedOption.label);
    };

    useEffect(() => {
        const fetchExamData = () => {
            http
                //.get('/getActiveExam')
                .get('/getMergeActiveExam')
                .then((response) => {
                    setExamData(response.data.activeexam);
                })
                .catch((error) => {
                    const status = error.response?.data?.http_status;
                    const message = error.response?.data?.message || "Something went wrong";

                    if (status === 401 && error.response?.data?.status_code === "ERR9") {
                        toast.error("Invalid Token");
                        setTimeout(() => navigate("/"), 5000);
                    } else if (status === 429 && error.response?.data?.status_code === "ERR33") {
                        toast.error(message);
                    } else if (status === 500 && error.response?.data?.status_code === "ERR5") {
                        toast.error("No active exam found");
                    } else {
                        toast.error(message);
                    }
                });
        };

        fetchExamData();
    }, []);


    useEffect(() => {
        const fetchData = () => {
            http.get(`/College/getCollegeOptedDisciplines`, {
                params: {

                    examid: selectExamId,
                    examtype:selectExamType
                }
            }).then((response) => {
                if (response.data.status_code === 'ERR5') {
                    setflag(true);

                }
                setDisciplineData(response.data);

            }).catch((error) => {
                if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);
                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error("Something went wrong");
                }
                console.error('Error fetching Course data:', error);
            }
            )
        };
        if (selectExamId || selectExamType) {
            fetchData();
            // setCourseId(false);
        }
    }, [selectExamId,selectExamType]);

    useEffect(() => {
        const fetchStudentList = () => {
            http.get(`/College/getcollegecoursebasedondisilpline`, {
                params: {
                    examid: selectExamId,
                    examtype:selectExamType,
                    discipline_id: disciplineId,
                    college_course_type: disciplinetype,

                }
            }).then((response) => {
                setCourse(response.data);

            }).catch((error) => {
                const status = error.response?.data?.http_status;
                const message = error.response?.data?.message || "Something went wrong";

                if (status === 401 && error.response?.data?.status_code === "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => navigate("/"), 5000);
                } else if (status === 429 && error.response?.data?.status_code === "ERR33") {
                    toast.error(message);
                } else if (status === 500 && error.response?.data?.status_code === "ERR5") {
                    toast.error("No data found");
                } else {
                    toast.error(message);
                }
            })
        };

        if (selectExamId && disciplineId) {
            fetchStudentList()
        }

    }, [selectExamId, disciplineId]);

    const handleCollegeLevelGeneratePDF = async (selectExamId,selectExamType, disciplineId, courseId, disciplinetype, disciplineName, courseName) => {
        if (!selectExamId || selectExamId === '' || selectExamId === false) {
            toast.error('Please select an exam');

        }
        else {

            let pdfname = "";
            if (disciplineId && courseId) {
                pdfname = `${username}_${disciplineName}_${courseName}_CollegeLevelCOAttainmentChart.pdf`;
            }
            else if (disciplineId && (courseId === '' || courseId === false)) {

                pdfname = `${username}_${disciplineName}_CollegeLevelCOAttainmentChart.pdf`;
            }
            else if ((disciplineId === '' || disciplineId === false) && courseId) {
                pdfname = `${username}_${courseName}_CollegeLevelCOAttainmentChart.pdf`;

            }
            else {
                pdfname = `${username}_CollegeLevelCOAttainmentChart.pdf`;
            }
            setloading(true);

            try {
                const response = await http.get('College/CollegeCourseCOAttainPdf', {
                    params: {
                        examid: selectExamId,
                        examtype:selectExamType,
                        discipline_id: disciplineId,
                        course_id: courseId,
                        college_course_type: disciplinetype
                    },
                    responseType: 'blob', // Expect binary response
                });

                if (response && response.data) {
                    // Create a URL for the downloaded file
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;

                    // Set the file name and download the PDF
                    link.setAttribute('download', pdfname);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    setloading(false);
                    toast.success('PDF generated successfully');
                }
                // setSelectExamId(false);
                setDisciplineId(null);
                setCourseId([]);
                setDisciplineTypeChange(null);
                setDisciplineName([]);
                setCourseName([]);
            } catch (error) {

                if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
                    toast.error(error.response.data.message);
                }
                else {
                    console.error('Error generating PDF:', error);
                    toast.error('Error generating PDF');
                }
            }
        }
    };
    const handleUniversityLevelGeneratePDF = async (selectExamId,selectExamType, disciplineId, courseId, disciplineName, courseName) => {
        if (!selectExamId || selectExamId === '' || selectExamId === false) {
            toast.error('Please select an exam');

        }

        else {
            let pdfname = "";
            if (disciplineId && courseId) {
                pdfname = `${username}_${disciplineName}_${courseName}_UniversityLevelCOAttainmentChart.pdf`;
            }
            else if (disciplineId && (courseId === '' || courseId === false)) {

                pdfname = `${username}_${disciplineName}_UnversityLevelCOAttainmentChart.pdf`;
            }
            else if ((disciplineId === '' || disciplineId === false) && courseId) {
                pdfname = `${username}_${courseName}_UnversityLevelCOAttainmentChart.pdf`;

            }
            else {
                pdfname = `${username}_UniversityLevelCOAttainmentChart.pdf`;
            }
            setloading(true);
            try {
                const response = await http.get('College/UniversityCourseCOAttainPdf', {
                    params: {
                        examid: selectExamId,
                        examtype:selectExamType,
                        discipline_id: disciplineId,
                        course_id: courseId
                    },
                    responseType: 'blob', // Expect binary response
                });

                if (response && response.data) {
                    // Create a URL for the downloaded file
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;

                    // Set the file name and download the PDF
                    link.setAttribute('download', pdfname);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    setloading(false);
                    toast.success('PDF generated successfully');
                }
                // setSelectExamId(false);
                setDisciplineId(null);
                setCourseId([]);
                setDisciplineTypeChange(null);
                setDisciplineName([]);
                setCourseName([]);
            } catch (error) {

                if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
                    toast.error(error.response.data.message);
                }
                else {
                    console.error('Error generating PDF:', error);
                    toast.error('Error generating PDF');
                }
            }
        }

    }

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
        }),
        /* Additional custom scrollbar styling for WebKit-based browsers */
        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };

    return (
        <>
            <ToastContainer />
            <Template>

                {loading ? (
                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                        <div className="containeranimate">
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (

                    <div className="adl-stl-page">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card">
                                        <div className="col-md-12">
                                            <div className="card-header">
                                                <div className="py-3 d-flex justify-content-between align-items-center ">
                                                    <h5>MGU-UGP/BBA/BCA(HONOURS) CO ATTAINMENT CALCULATION CHART</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="card-body pdg">
                                                <div className="table-responsive">
                                                    <form className="form theme-form">
                                                        <div className="card-body custom-input">
                                                            <div className="col">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <label>Exam<span className="errorclr">*</span></label>

                                                                        <Select
                                                                            maxMenuHeight={200}
                                                                            menuPlacement="auto"
                                                                            id="exam_id"
                                                                            name="exam_id"
                                                                            className="basic-select"
                                                                            classNamePrefix="select"
                                                                            onChange={handleChangeExam}
                                                                            options={getexamData.map(exam => ({
                                                                                value: `${exam.examid}_${exam.examtype}`,
                                                                                examid: exam.examid,
                                                                                label: exam.examtitle,
                                                                                examtype: exam.examtype,
                                                                            }))}
                                                                            value={selectedExamId.length > 0 ? selectedExamId.map(exam => ({
                                                                                value: exam.value,
                                                                                examid: exam.examid,
                                                                                label: exam.label,
                                                                                examtype: exam.examtype,
                                                                            })
                                                                            ) : []}

                                                                            placeholder="Select an exam..."
                                                                        />

                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <label>Discipline </label>
                                                                        <Select
                                                                            maxMenuHeight={200}
                                                                            menuPlacement="auto"
                                                                            id="discipline_id"
                                                                            name="discipline_id"
                                                                            className="form"
                                                                            styles={disciplineStyles}
                                                                            onChange={handleDisciplineChange}
                                                                            options={Array.isArray(disciplinedata) && disciplinedata.length > 0
                                                                                ? disciplinedata
                                                                                    .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                                                                    .map(discipline => ({
                                                                                        disciplineid: discipline.id,
                                                                                        value: discipline.discipline_name,
                                                                                        label: discipline.discipline_name,
                                                                                        type: discipline.college_course_type
                                                                                    }))
                                                                                : [{ value: '0', label: 'No data found' }]
                                                                            }
                                                                            value={disciplinedata && Array.isArray(disciplinedata)
                                                                                ? disciplinedata
                                                                                    .filter(discipline =>
                                                                                        discipline.id.toString() === disciplineId &&
                                                                                        discipline.college_course_type === disciplinetype // Added filter for discipline_type
                                                                                    )
                                                                                    .map(discipline => ({
                                                                                        value: discipline.discipline_name,
                                                                                        label: discipline.discipline_name,
                                                                                    }))[0]
                                                                                : null}
                                                                        />

                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label>Course</label>
                                                                        <Select
                                                                            maxMenuHeight={200}
                                                                            menuPlacement="auto"
                                                                            id="discipline_id"
                                                                            name="discipline_id"
                                                                            className="form"
                                                                            styles={customStyles}
                                                                            onChange={handlecourseChange}
                                                                            options={Array.isArray(course) && course.length > 0
                                                                                ? course
                                                                                    .sort((a, b) => a.course_name.localeCompare(b.course_name))
                                                                                    .map(course => ({
                                                                                        value: course.id,
                                                                                        label: course.course_name,

                                                                                    }))
                                                                                : [{ value: '0', label: 'No data found' }]
                                                                            }
                                                                            value={course && Array.isArray(course)
                                                                                ? course
                                                                                    .filter(course =>
                                                                                        course.id.toString() === courseId
                                                                                    )
                                                                                    .map(course => ({
                                                                                        value: course.id,
                                                                                        label: course.course_name,
                                                                                    }))[0]
                                                                                : null}
                                                                        />

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                    <div class="container py-4">
                                                        <div class="row justify-content-center">
                                                            <div class="col-md-8 text-center">
                                                                <h2 class="mb-4 fw-bold text-dark">
                                                                    Download PDF  <i class="bi bi-download me-2"></i>
                                                                </h2>
                                                                <div class="d-grid gap-3 d-md-flex justify-content-md-center">
                                                                    <button type="button" class="btn btn-outline-primary btn-lg px-4 shadow-sm"
                                                                        onClick={() => handleCollegeLevelGeneratePDF(selectExamId,selectExamType, disciplineId, courseId, disciplinetype, disciplineName, courseName)}>
                                                                        <i class="bi bi-mortarboard me-2"></i>
                                                                        College Level
                                                                    </button>
                                                                    <button type="button" class="btn btn-outline-success btn-lg px-4 shadow-sm"
                                                                        onClick={() => handleUniversityLevelGeneratePDF(selectExamId,selectExamType, disciplineId, courseId, disciplineName, courseName)}>
                                                                        <i class="bi bi-building me-2"></i>
                                                                        University Level
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}


            </Template>
        </>
    );
}